import { render, staticRenderFns } from "./_CourseRecognitionQuestionDialog.vue?vue&type=template&id=2dbd2db1&"
import script from "./_CourseRecognitionQuestionDialog.vue?vue&type=script&lang=js&"
export * from "./_CourseRecognitionQuestionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports